import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=67db61ff&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=67db61ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db61ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67db61ff')) {
      api.createRecord('67db61ff', component.options)
    } else {
      api.reload('67db61ff', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=67db61ff&scoped=true&", function () {
      api.rerender('67db61ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uDwREESTWCmT/JS/pricehelp.vue"
export default component.exports